import { Injectable } from '@angular/core';
import { IAfiGeoposition } from './geoposition.model';
import {Yii} from "../../interfaces/Yii";

@Injectable()
export class GeopositionService {
    public isEmpty(geoposition: IAfiGeoposition): boolean {
        return !geoposition
            || geoposition.latitude === undefined
            || geoposition.latitude === null
            || geoposition.longitude === undefined
            || geoposition.longitude === null
            || !geoposition.radius
            || geoposition.radius.max === undefined
            || geoposition.radius.max === null
            || geoposition.radius.unit === null
            || geoposition.radius.unit === null;
    }

    public getGeopositionLabel(geoposition: IAfiGeoposition): string {
        if (geoposition &&
            geoposition.latitude !== null &&
            geoposition.latitude !== undefined &&
            geoposition.longitude !== null &&
            geoposition.longitude !== undefined
        ) {
            return Yii.t('wui-shared-js', 'Coord : ') + Number(geoposition.latitude).toFixed(2) + " - " + Number(geoposition.longitude).toFixed(2);
        }
        return Yii.t('wui-shared-js', 'Coord');
    }
}